module.exports = __webpack_public_path__ + "static/media/turbines-mob.56fe4cc6.jpg";